import { render, staticRenderFns } from "./footer.vue?vue&type=template&id=703e3f66&scoped=true"
import script from "./footer.vue?vue&type=script&lang=js"
export * from "./footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e3f66",
  null
  
)

export default component.exports